<template>
  <div class="auth-page auth-page--login">
    <div class="auth-page__inner">
      <div class="auth-page__title">{{ $t("login.title") }}</div>
      <div class="auth-page__sub-title">
        {{ $t("login.sub_title") }}
      </div>
      <div class="auth-page__fields">
        <div class="auth-page__field">
          <text-input
            ref="phoneInput"
            :title="$t('login.notary_phone')"
            :mask="'+38 (###) ###-##-##'"
            :errors="v$.phone.$errors"
            @enterPressed="startLogin"
            v-model="phone"
          ></text-input>
        </div>
        <div class="auth-page__field" v-if="needAgreedWithTerms">
          <checkbox-input
            v-model="isAgree"
            :errors="v$.isAgree.$errors"
            :text="$t('registration.agreed')"
          ></checkbox-input>
        </div>
      </div>
      <div class="auth-page__actions">
        <primary-button
          class="auth-page__action auth-page__action--half"
          :text="$t('login.sign_in.btn')"
          @click="startLogin"
        ></primary-button>
        <transparent-button
          class="auth-page__action auth-page__action--half"
          :text="$t('login.sign_up.btn')"
          @click="toSignUp"
        ></transparent-button>
      </div>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/buttons/PrimaryButton";
import TransparentButton from "@/components/buttons/TransparentButton";
import TextInput from "@/components/inputs/TextInput";
import { AuthApi } from "@/office/auth/auth-api";
import {
  SET_LOGIN_TRANSACTION_ID,
  SET_OTP_OPERATION_ID,
  SET_USER_PHONE,
} from "@/store/action-types";

import useVuelidate from "@vuelidate/core";
import { required, minLength, helpers, sameAs } from "@vuelidate/validators";
import CheckboxInput from "@/components/inputs/CheckboxInput.vue";

export default {
  name: "Login",
  components: { CheckboxInput, TextInput, TransparentButton, PrimaryButton },
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  data() {
    return {
      phone: "+380",
      vuelidateExternalResults: {
        phone: "",
        isAgree: "",
      },
      isLoginStarted: false,
      isAgree: false,
      needAgreedWithTerms: false,
    };
  },
  validations() {
    let defaultValidators = {
      phone: {
        required: helpers.withMessage("phone_required", required),
        minLength: helpers.withMessage("phone_incorrect", minLength(19)),
      },
    };

    if (this.needAgreedWithTerms) {
      defaultValidators = {
        ...defaultValidators,
        isAgree: {
          checked: helpers.withMessage("agreed_required", sameAs(true)),
        },
      };
    }

    return defaultValidators;
  },
  mounted() {
    this.$refs.phoneInput.focus();
  },
  methods: {
    async startLogin() {
      if (this.isLoginStarted) {
        return false;
      }

      const isValid = await this.v$.$validate();

      if (!isValid) {
        return;
      }

      this.isLoginStarted = true;

      new AuthApi()
        .startLogin(this.phone, this.isAgree)
        .then(async (r) => {
          if (r.data.success) {
            await this.$store.dispatch(SET_USER_PHONE, this.phone);
            await this.$store.dispatch(
              SET_OTP_OPERATION_ID,
              r.data.operation_id
            );

            if (r.data.is_phone_call) {
              await this.$store.dispatch(
                SET_LOGIN_TRANSACTION_ID,
                r.data.transaction_id
              );
              this.$router.push("/login/phone-call");
            } else if (r.data.is_custom_otp_code) {
              this.$router.push("/login/otp/custom");
            } else {
              this.$router.push("/login/otp");
            }
          }
        })
        .catch((err) => {
          if (err.data.message === "user_not_agreed_with_new_terms") {
            this.needAgreedWithTerms = true;
          } else {
            Object.assign(this.vuelidateExternalResults, {
              phone: err.data.message,
            });
          }

          this.isLoginStarted = false;

          setTimeout(() => {
            this.v$.$clearExternalResults();
          }, 3000);
        })
        .finally(() => {
          this.isLoginStarted = false;
        });
    },
    toSignUp() {
      this.$router.push("/sign-up");
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-page {
  &__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 25px;
  }

  &__action {
    &--half {
      width: calc(50% - 5px);
    }
  }
}
</style>
